import { com } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import AuthenticationContext from '../../authorization/AuthenticationContext'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import { logMessage } from '../../../util/Logging'
import { parseEntityTypeFromJsonString } from './parseEntityTypeResponse'

type GetEntityTypeParameters = { id: EntityTypeId; authContext: AuthenticationContext }

const getEntityType = ({ id, authContext }: GetEntityTypeParameters): Promise<EntityType | null> =>
  fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/types/${id.toString()}`, {
    headers: {
      Authorization: `Bearer ${authContext.accessToken}`,
      Accept: 'application/json',
    },
  }).then(async (response) => {
    switch (response.status) {
      case 200:
        return parseEntityTypeFromJsonString(await response.text())
      case 404:
        logMessage(`Got status ${response.status} from getEntityType endpoint`, 'warning')
        return null
      default:
        throw Error(`Unexpected response code ${response.status} from getEntityType endpoint`)
    }
  })

export default getEntityType
